<template>
    <div class="order-confirmation-page">
        <div class="container">
                        <div v-if="!success">
                                <div style="margin-bottom: 1rem;">
                                        <img class="logo" src="@/assets/logo.png" alt="EliteFitness" />
                                </div>

                                <!-- WEB: fotocamera (zxing) -->
                                <div v-if="!IS_KIOSK && !orders.length" style="margin-bottom: 1rem;">
                                        <h3>Inquadra il QR Code dell'ordine</h3>
                                </div>

                                <div v-if="!IS_KIOSK" style="display:flex;flex-direction:column;align-items:center;gap:12px;">
                                        <video ref="videoEl" autoplay playsinline webkit-playsinline muted style="width: 320px; max-width: 90vw; border-radius: 8px; background: #111;"></video>
                                        <div v-if="scanning" style="font-size: 0.95rem;">
                                                Scansione in corso
                                                <span class="loading-dots"><span>•</span><span>•</span><span>•</span></span>
                                        </div>
                                    <div v-if="needsUserGesture" style="display:flex;flex-direction:column;align-items:center;gap:10px;">
                                        <small>Per usare la fotocamera su questo dispositivo devi autorizzarla.</small>
                                        <button class="btn-custom" :disabled="loading" @click="requestCameraPermission">Abilita fotocamera</button>
                                    </div>
                                </div>

                                <!-- KIOSK: attesa scansione col lettore Zebra -->
                                <div v-if="IS_KIOSK && !orders.length && !scanConfirming" class="kscan">
                                    <div class="kscan__frame">
                                        <span class="kscan__corner kscan__corner--tl"></span>
                                        <span class="kscan__corner kscan__corner--tr"></span>
                                        <span class="kscan__corner kscan__corner--bl"></span>
                                        <span class="kscan__corner kscan__corner--br"></span>
                                        <svg class="kscan__qr" viewBox="0 0 448 512" width="96" height="96" aria-hidden="true">
                                            <path fill="currentColor" d="M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96zm64 16v64h64v-64H64zM256 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80zm64 16v64h64V96h-64zM256 288h64v64h-64v-64zm128 0h64v64h-64v-64zM320 416h64v64h-64v-64zm128-64v128h-64v-64h-64v-64h128z"/>
                                        </svg>
                                        <div class="kscan__beam"></div>
                                    </div>
                                    <h3 class="kscan__title">Avvicina il QR dell'ordine al lettore</h3>
                                    <p class="kscan__hint">Trovi il QR nell'email di conferma dell'ordine.</p>
                                    <div class="kscan__listening"><span class="kscan__dot"></span> In ascolto…</div>
                                </div>

                                <!-- KIOSK: conferma di scansione + recupero ordine -->
                                <div v-else-if="IS_KIOSK && scanConfirming" class="kscan kscan--confirm">
                                    <div class="kscan__badge">
                                        <svg viewBox="0 0 24 24" width="54" height="54" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
                                    </div>
                                    <h3 class="kscan__title">Codice rilevato</h3>
                                    <div class="kscan__spinner"></div>
                                    <p class="kscan__hint">Recupero dell'ordine…</p>
                                </div>

                <div v-if="orders.length && !scanConfirming" style="margin-top: 2rem; text-align:left; background: rgba(255,255,255,0.06); padding: 16px; border-radius: 8px;">
                                        <h3 style="margin-top:0;">Ordini rilevati</h3>
                                        <ul style="list-style:none; padding:0; margin:0;">
                        <li v-for="(o, idx) in orders" :key="idx" style="padding:8px 0; border-bottom: 1px solid rgba(255,255,255,0.1);">
                            <div style="display:flex; justify-content:space-between;">
                                <span>{{ o.description }}</span>
                                <span>{{ formatCurrency(o.amount) }}</span>
                            </div>
                            <div v-if="o.promoCode && Number(o.discountAmount) > 0" style="display:flex; justify-content:space-between; padding-top:4px; font-size:0.9rem; opacity:0.9;">
                                <span>Sconto ({{ o.promoCode }})</span>
                                <span>-{{ formatCurrency(o.discountAmount) }}</span>
                            </div>
                            <div v-if="Number(o.alreadyPaid) > 0" style="display:flex; justify-content:space-between; padding-top:4px; font-size:0.9rem; opacity:0.9;">
                                <span>Già pagato</span>
                                <span>-{{ formatCurrency(o.alreadyPaid) }}</span>
                            </div>
                            <div style="display:flex; justify-content:space-between; padding-top:4px; font-weight:600;">
                                <span>Da incassare</span>
                                <span>{{ formatCurrency(o.remainingAmount) }}</span>
                            </div>
                        </li>
                                        </ul>
                                        <div style="display:flex; justify-content:space-between; padding-top: 12px; font-weight: 600;">
                                                <span>Totale da incassare</span>
                                                <span>{{ formatCurrency(total) }}</span>
                                        </div>
                                        <div style="margin-top: 16px; display:flex; gap: 8px;">
                                                <button class="btn-custom" :disabled="loading" @click="confirmPayment">Conferma pagamento</button>
                                                <button class="btn-custom" :disabled="loading" style="background:#666;" @click="restartScan">Scansiona di nuovo</button>
                                        </div>
                                </div>

                                <div v-if="error" class="error">{{ error }}</div>
                        </div>

                        <div v-else>
                                <h2>Pagamento confermato</h2>
                                <p>Operazione completata con successo.</p>
                                <div style="margin-top: 16px;">
                                        <button class="btn-custom" @click="restartScan">Nuova scansione</button>
                                </div>
                        </div>
        </div>
        
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import Swal from 'sweetalert2'
import { useRoute, useRouter } from 'vue-router'
import { IS_KIOSK, hasKioskBridge } from '@/config/kiosk'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const error = ref(null)
const success = ref(false)
const scanning = ref(false)
// Kiosk: true dal momento in cui il lettore Zebra rileva un QR valido fino a
// quando il riepilogo ordine è pronto (mostra la conferma "codice rilevato").
const scanConfirming = ref(false)
const orders = ref([])
const total = ref(0)
const userToken = ref('')
const needsUserGesture = ref(false)
const centers = ref([])
// Stato dell'incasso live sul Cashmatic (solo modalità kiosk).
const kioskProgress = ref(null)

const videoEl = ref(null)
let mediaStream = null
let rafId = null
let detector = null
let detectionLocked = false
let zxingReader = null
let zxingControls = null

function formatCurrency(value){
    try{
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(value||0))
    }catch{
        return `${Number(value||0).toFixed(2)} €`
    }
}

function resetState(){
    loading.value = false
    error.value = null
    success.value = false
    orders.value = []
    total.value = 0
    detectionLocked = false
    needsUserGesture.value = false
    scanConfirming.value = false
}

async function startScan(){
    resetState()
    scanning.value = true

    if('BarcodeDetector' in window){
        try{
            detector = new window.BarcodeDetector({ formats: ['qr_code'] })
        }catch(e){
            error.value = 'Impossibile inizializzare lo scanner.'
            scanning.value = false
            return
        }
        try{
            mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false })
            if(videoEl.value){
                videoEl.value.srcObject = mediaStream
                // Ensure inline playback on iOS
                videoEl.value.setAttribute('playsinline','true')
                videoEl.value.setAttribute('webkit-playsinline','true')
                videoEl.value.muted = true
                videoEl.value.playsInline = true
                await new Promise(res => {
                    const handler = () => { videoEl.value && videoEl.value.removeEventListener('loadedmetadata', handler); res() }
                    videoEl.value.addEventListener('loadedmetadata', handler)
                })
                try{ await videoEl.value.play() }catch(_){ /* ignore */ }
            }
            needsUserGesture.value = false
            error.value = null
            loopDetect()
        }catch(e){
            if(e && (e.name === 'NotAllowedError' || e.name === 'SecurityError')){
                needsUserGesture.value = true
                error.value = 'Consenti l\'accesso alla fotocamera per procedere.'
            }else if(!window.isSecureContext){
                error.value = 'La fotocamera richiede HTTPS o localhost.'
            }else{
                error.value = 'Permesso fotocamera negato o non disponibile.'
            }
            scanning.value = false
        }
        return
    }

    // Fallback: ZXing for broader mobile support (iOS Safari etc.)
    try{
        const zxing = await import(/* webpackChunkName: "zxing" */ '@zxing/browser')
        const { BrowserMultiFormatReader } = zxing
        zxingReader = new BrowserMultiFormatReader()

        // Ensure inline playback attributes before binding stream
        if(videoEl.value){
            videoEl.value.setAttribute('playsinline','true')
            videoEl.value.setAttribute('webkit-playsinline','true')
            videoEl.value.muted = true
            videoEl.value.playsInline = true
            videoEl.value.autoplay = true
        }

        const constraints = {
            audio: false,
            video: {
                facingMode: { ideal: 'environment' }
            }
        }

        zxingControls = await zxingReader.decodeFromConstraints(constraints, videoEl.value, async (result) => {
            if(result && !detectionLocked){
                detectionLocked = true
                if(zxingControls){
                    zxingControls.stop()
                    zxingControls = null
                }
                await onQrDetected(result.getText())
            }
        })
        // Consider camera active
        needsUserGesture.value = false
        error.value = null
    }catch(e){
        needsUserGesture.value = true
        if(!window.isSecureContext){
            error.value = 'La fotocamera richiede HTTPS o localhost.'
        }else{
            error.value = 'Per usare la fotocamera è richiesta un\'azione dell\'utente.'
        }
        scanning.value = false
    }
}

function stopScan(){
    scanning.value = false
    if(rafId){
        cancelAnimationFrame(rafId)
        rafId = null
    }
    if(zxingControls){
        try{ zxingControls.stop() }catch(_){/* noop */}
        zxingControls = null
    }
    if(mediaStream){
        mediaStream.getTracks().forEach(t => t.stop())
        mediaStream = null
    }
}

function loopDetect(){
    const tick = async () => {
        if(!scanning.value || detectionLocked) return
        try{
            if(videoEl.value && detector){
                const codes = await detector.detect(videoEl.value)
                if(codes && codes.length){
                    detectionLocked = true
                    const payload = codes[0].rawValue || ''
                    await onQrDetected(payload)
                    return // stop loop here; onQrDetected will manage restart if needed
                }
            }
        }catch(e){
            // swallow and continue
        }
        rafId = requestAnimationFrame(tick)
    }
    rafId = requestAnimationFrame(tick)
}

function parseOrderIds(payload){
    if(!payload || typeof payload !== 'string') return []
    // Expected: "id1;id2;id3"; allow whitespace and trailing separators
    const ids = payload.split(';').map(s => s.trim()).filter(Boolean)
    // Deduplicate
    return Array.from(new Set(ids))
}

async function onQrDetected(payload){
    stopScan()
    // Disarma il lettore Zebra: finché non si riparte esplicitamente (restartScan)
    // nessuna scansione parassita può sostituire l'ordine/totale mostrato.
    stopZebraListener()
    const ids = parseOrderIds(payload)
    if(!ids.length){
        await Swal.fire('QR non valido', 'Nessun orderId trovato nel QR. Riprovare.', 'error')
        restartScan()
        return
    }
    try{
        // Azzera l'eventuale ordine precedente e mostra subito la conferma
        // "codice rilevato" mentre recuperiamo l'ordine.
        orders.value = []
        total.value = 0
        scanConfirming.value = true
        loading.value = true
        // Timeout: su rete lenta/hang del bridge evita di restare bloccati sullo spinner.
        const fetchP = fetchOrders(ids)
        fetchP.catch(() => {})  // evita unhandled rejection se vince il timeout
        const fetched = await Promise.race([
            fetchP,
            new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 15000))
        ])
        if(!Array.isArray(fetched) || fetched.length === 0){
            await Swal.fire('Nessun ordine', 'Nessun ordine da pagare per questo QR. Riprovare.', 'info')
            restartScan()
            return
        }
        orders.value = fetched
        total.value = fetched.reduce((acc, o) => acc + Number(o.remainingAmount ?? o.amount ?? 0), 0)
    }catch(e){
        await Swal.fire('QR non corretto', 'Impossibile recuperare uno o più ordini. Riprovare.', 'error')
        restartScan()
        return
    }finally{
        loading.value = false
        scanConfirming.value = false
    }
}

async function fetchOrders(ids){
    let data
    if(IS_KIOSK && hasKioskBridge()){
        // Il gateway firma HMAC e recupera i riepiloghi dal backend.
        const res = await window.kioskPay.getSummaries(ids)
        if(!res || !res.ok) throw new Error((res && res.error) || 'Order fetch failed')
        data = res.data
    }else{
        const url = 'https://api.elitefitness.it/api/orders/summaries?' + ids.map(id => 'ids=' + encodeURIComponent(id)).join('&')
        const res = await fetch(url, { headers: { 'Authorization': `Bearer ${userToken.value}` } })
        if(!res.ok) throw new Error('Order fetch failed')
        data = await res.json()
    }
    if(!Array.isArray(data)) throw new Error('Invalid order payload')
    return data.map(o => ({
        id: o.id,
        description: o.description,
        amount: Number(o.amount ?? 0),
        promoCode: o.promoCode ?? null,
        discountAmount: Number(o.discountAmount ?? 0),
        alreadyPaid: Number(o.alreadyPaid ?? 0),
        remainingAmount: Number(o.remainingAmount ?? o.amount ?? 0)
    }))
}

async function confirmPayment(){
    // Modalità kiosk: incasso in contanti sul Cashmatic tramite il gateway,
    // niente scelta manuale di metodo/centro (il centro deriva dal kiosk lato
    // server). Il renderer non conosce token né segreti.
    if(IS_KIOSK){
        return confirmPaymentKiosk()
    }

    const totalFmt = formatCurrency(total.value)

    // Step 1: scelta metodo pagamento
    const methodChoice = await Swal.fire({
        title: 'Seleziona metodo di pagamento',
        text: "Scegli come ha pagato l'utente",
        icon: 'question',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Contanti', // CASH
        denyButtonText: 'POS',         // DEBIT_CARD
        cancelButtonText: 'Annulla'
    })

    if(methodChoice.isDismissed) return
    const method = methodChoice.isConfirmed ? 'CASH' : (methodChoice.isDenied ? 'DEBIT_CARD' : null)
    if(!method) return

    const methodLabel = method === 'CASH' ? 'Contanti' : 'POS'

    // Step 2: selezione centro
    let centerId = null
    try{
        if(!centers.value.length){
            const list = await fetchOpenCenters()
            centers.value = list
        }
    }catch(_){
        // ignore, we'll fallback to manual input
    }

    if(centers.value.length){
        const inputOptions = centers.value.reduce((acc, c) => {
            const id = c.id || c._id || ''
            const name = c.name || c.label || id
            if(id) acc[id] = name
            return acc
        }, {})
        const centerChoice = await Swal.fire({
            title: 'Seleziona il centro',
            input: 'select',
            inputOptions,
            inputPlaceholder: 'Scegli un centro',
            showCancelButton: true,
            confirmButtonText: 'Continua',
            cancelButtonText: 'Annulla'
        })
        if(centerChoice.isDismissed) return
        centerId = String(centerChoice.value || '')
        if(!centerId){
            await Swal.fire('Centro richiesto', 'Seleziona un centro per continuare.', 'warning')
            return
        }
    }else{
        const networkErr = await Swal.fire({
            title: 'Errore di rete',
            text: "Impossibile caricare l'elenco dei centri. Verifica la connessione e riprova.",
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Ricarica',
            cancelButtonText: 'Annulla'
        })
        if(networkErr.isConfirmed){
            window.location.reload()
        }
        return
    }

    const centerName = (() => {
        const found = centers.value.find(c => (c.id || c._id) === centerId)
        return found ? (found.name || found.label || centerId) : centerId
    })()

    // Step 2: conferma finale con totale e metodo scelto
    const result = await Swal.fire({
        title: `Confermi che l'utente ha pagato ${totalFmt} con ${methodLabel} presso ${centerName}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Conferma',
        cancelButtonText: 'Annulla'
    })
    if(!result.isConfirmed) return

    try{
        loading.value = true
        
        // Genera una chiave idempotente univoca per questa richiesta
        // Questo previene elaborazioni duplicate in caso di retry o doppie chiamate
        const idempotencyKey = crypto.randomUUID ? crypto.randomUUID() : generateUUID()
        
        const res = await fetch('https://api.elitefitness.it/api/orders/paySome', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userToken.value}`,
                'Idempotency-Key': idempotencyKey
            },
            body: JSON.stringify({
                orderIds: orders.value.map(o => o.id),
                method,
                centerId
            })
        })
        if(!res.ok){
            const text = await res.text().catch(() => '')
            throw new Error(text || 'Errore nella conferma di pagamento')
        }
        await Swal.fire('Operazione riuscita', 'Pagamento confermato.', 'success')
        success.value = true
    }catch(e){
        await Swal.fire('Errore', e?.message || 'Impossibile confermare il pagamento.', 'error')
    }finally{
        loading.value = false
    }
}

async function confirmPaymentKiosk(){
    if(!hasKioskBridge()){
        await Swal.fire('Kiosk non disponibile', 'Il modulo di pagamento del kiosk non è attivo.', 'error')
        return
    }
    const amountCents = Math.round(Number(total.value) * 100)
    const orderIds = orders.value.map(o => o.id)
    let unsub = null
    try{
        loading.value = true
        kioskProgress.value = { inserted: 0, requested: amountCents }
        unsub = window.kioskPay.onProgress(p => { kioskProgress.value = p })
        const res = await window.kioskPay.payCash({ orderIds, amount: amountCents })
        if(res && res.collected && res.orderConfirmed){
            if(res.notDispensed && res.notDispensed > 0){
                await Swal.fire('Incassato — resto non erogato',
                    `La macchina non ha potuto erogare ${formatCurrency(res.notDispensed/100)} di resto. Rivolgersi alla reception.`, 'warning')
            }
            goToKioskSuccess()
            return
        }else if(res && res.collected && !res.orderConfirmed){
            await Swal.fire('Incasso ricevuto',
                'Il pagamento è stato incassato ma la conferma è in sospeso. Rivolgersi alla reception con la ricevuta.', 'warning')
            goToKioskSuccess()
            return
        }else{
            const msg = (res && res.collect && res.collect.end) ? `Esito: ${res.collect.end}`
                : ((res && res.error) || 'Pagamento non completato.')
            await Swal.fire('Pagamento non riuscito', msg, 'error')
        }
    }catch(e){
        await Swal.fire('Errore', e?.message || 'Errore durante il pagamento.', 'error')
    }finally{
        loading.value = false
        kioskProgress.value = null
        if(unsub) unsub()
    }
}

// Kiosk: dopo il pagamento dell'ordine scansionato non mostriamo la vista inline
// "Pagamento confermato"; andiamo alla SuccessPage (ringraziamento + QR app +
// auto-dismiss 30s → home), coerente col flusso di nuovo acquisto.
function goToKioskSuccess(){
    router.push({ path: '/success', query: { method: 'CASH_KIOSK', source: 'kiosk' } })
}

function restartScan(){
    stopScan()
    resetState()
    if(IS_KIOSK){
        // Al kiosk lo scanner è il lettore Zebra: niente fotocamera.
        stopZebraListener()
        startZebraListener()
    }else{
        startScan()
    }
}

async function requestCameraPermission(){
    try{
        loading.value = true
        // Chiede il permesso in risposta a gesto utente
        const tmpStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
        // Chiude subito lo stream temporaneo
        tmpStream.getTracks().forEach(t => t.stop())
        needsUserGesture.value = false
        await startScan()
    }catch(e){
        if(!window.isSecureContext){
            error.value = 'La fotocamera richiede HTTPS o localhost.'
        }else{
            error.value = 'Permesso negato. Controlla le impostazioni del browser.'
        }
    }finally{
        loading.value = false
    }
}

async function fetchOpenCenters(){
    const url = 'https://api.elitefitness.it/api/open/centers'
    const res = await fetch(url)
    if(!res.ok) throw new Error('Centers fetch failed')
    const data = await res.json()
    if(!Array.isArray(data)) return []
    return data
}

// Genera un UUID v4 come fallback per browser che non supportano crypto.randomUUID()
function generateUUID(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}

onMounted(() => {
    userToken.value = String(route.query.userToken || '')
    // In modalità kiosk l'autenticazione verso il backend la fa il gateway
    // (window.kioskPay, firma HMAC): non serve alcun userToken JWT.
    if(!IS_KIOSK && !userToken.value){
        error.value = 'userToken mancante nei parametri della pagina.'
        return
    }
    if(IS_KIOSK){
        // Al kiosk lo scanner è il lettore fisico Zebra (keyboard-wedge): non
        // apriamo la fotocamera, ascoltiamo i tasti "digitati" dal lettore.
        startZebraListener()
    }else{
        startScan()
    }
})

onBeforeUnmount(() => {
    stopScan()
    stopZebraListener()
})

// --- Lettore fisico Zebra (keyboard-wedge) -------------------------------
// Il lettore invia i caratteri del codice come pressioni tasto seguite da
// Invio. Bufferizziamo e, a Invio, trattiamo il buffer come payload del QR.
let zebraBuffer = ''
function onZebraKey(e){
    if(loading.value || success.value) return
    if(e.key === 'Enter'){
        const payload = zebraBuffer
        zebraBuffer = ''
        e.preventDefault()
        if(payload) onQrDetected(payload)
        return
    }
    if(e.key && e.key.length === 1){
        zebraBuffer += e.key
    }
}
function startZebraListener(){
    zebraBuffer = ''
    window.addEventListener('keydown', onZebraKey)
}
function stopZebraListener(){
    window.removeEventListener('keydown', onZebraKey)
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

body {
    font-family: 'Montserrat', sans-serif;
    background-color: #2e348c;
}

h1,
h2,
h3,
h4 {
    font-family: 'Montserrat', sans-serif;
    font-size: 22px;
    font-weight: 600 !important;
}

@media (min-width: 1400px) {
    .order-confirmation .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
        max-width: 1320px;
        width: 500px;
    }
}

.order-confirmation-page{
    font-family: 'Montserrat', sans-serif;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #292D7D;
    color: white;
}

.btn-custom {
    font-family: 'Montserrat', sans-serif;
    background-color: #e83539;
    color: white;
    border: none;
    padding: 10px 20px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    border-radius: 0;
    font-size: 1.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.logo{
    width: 50px;
}

.loading-dots {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding-left: 5px;
}

.loading-dots span {
    display: inline-block;
    animation: bounce 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(1) {
    animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
    animation-delay: -0.16s;
}

.loading-dots span:nth-child(3) {
    animation-delay: 0s;
}

@keyframes bounce {
    0%, 80%, 100% {
        transform: scale(0);
        opacity: 0.5;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}

.error { color: white; margin-top: 1em; }
.success { color: #388e3c; margin-top: 1em; }
button[disabled] { opacity: 0.6; cursor: not-allowed; }

/* ===== Kiosk: attesa scansione + conferma =============================== */
.kscan {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 12px 8px 8px;
}
.kscan__frame {
    position: relative;
    width: 220px;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.05);
    overflow: hidden;
}
.kscan__qr {
    color: rgba(255, 255, 255, 0.55);
}
/* Angoli a "mirino" */
.kscan__corner {
    position: absolute;
    width: 34px;
    height: 34px;
    border: 4px solid #ffc933;
}
.kscan__corner--tl { top: 14px; left: 14px; border-right: none; border-bottom: none; border-top-left-radius: 8px; }
.kscan__corner--tr { top: 14px; right: 14px; border-left: none; border-bottom: none; border-top-right-radius: 8px; }
.kscan__corner--bl { bottom: 14px; left: 14px; border-right: none; border-top: none; border-bottom-left-radius: 8px; }
.kscan__corner--br { bottom: 14px; right: 14px; border-left: none; border-top: none; border-bottom-right-radius: 8px; }
/* Fascio che scorre */
.kscan__beam {
    position: absolute;
    left: 10%;
    right: 10%;
    height: 3px;
    border-radius: 3px;
    background: linear-gradient(90deg, transparent, #ffc933, transparent);
    box-shadow: 0 0 16px 3px rgba(255, 201, 51, 0.7);
    animation: kscan-beam 1.8s ease-in-out infinite;
}
@keyframes kscan-beam {
    0%   { top: 16%; opacity: 0.35; }
    50%  { top: 80%; opacity: 1; }
    100% { top: 16%; opacity: 0.35; }
}
.kscan__title {
    margin: 4px 0 0;
    font-size: 1.4rem !important;
    font-weight: 600;
}
.kscan__hint {
    margin: 0;
    font-size: 1rem;
    opacity: 0.8;
    max-width: 420px;
}
.kscan__listening {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    margin-top: 4px;
    font-size: 0.95rem;
    opacity: 0.85;
}
.kscan__dot {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #2ecc71;
    animation: kscan-pulse 1.2s ease-in-out infinite;
}
@keyframes kscan-pulse {
    0%, 100% { transform: scale(0.8); opacity: 0.5; }
    50%      { transform: scale(1.2); opacity: 1; }
}
/* Conferma di scansione */
.kscan__badge {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: #2ecc71;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: kscan-pop 0.34s cubic-bezier(0.2, 0.8, 0.3, 1.4);
}
@keyframes kscan-pop {
    0%   { transform: scale(0); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
}
.kscan__spinner {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: 6px solid rgba(255, 255, 255, 0.18);
    border-top-color: #ffc933;
    animation: kscan-spin 0.9s linear infinite;
    margin-top: 4px;
}
@keyframes kscan-spin { to { transform: rotate(360deg); } }
</style>
